import { Injectable } from '@angular/core';
import { SendMailDto } from 'src/app/models/dto/sendMail.dto';
import { ApiService } from '../api/api.service';
import { DbService } from '../db/db.service';
import { MailTemplate } from 'src/app/models/firebase/mailTemplate';
import { Project } from 'src/app/models/firebase/project';


@Injectable({
  providedIn: 'root'
})
export class MailerService {

  constructor(
    private api: ApiService,
    private db: DbService
  ) { }

  async send(mail: SendMailDto): Promise<any> {
    const result = this.api.post('/mailer/landing-send', mail).then(r => {
        return r;
    });
    return result
  }

  async deleteTemplate(id: string, projectId: string): Promise<any> {
    return await this.db.firestore
      .collection(Project.PATH)
      .doc(projectId)
      .collection(MailTemplate.PATH)
      .doc(id)
      .set({ deleted: true }, { merge: true });
  }


}
